import { ICON_ALERT_CIRCLE_OUTLINE, ICON_THUMB_UP_OUTLINE, MessageType } from '@doveit/bricks';
import { GoalMetric, PerformanceRating } from '../../../providers/api/dtos';

export const configByPerformanceRating: (targetAchieved: boolean) => Record<PerformanceRating, {
  messageType: MessageType,
  message: string,
  icon: string,
  modalTitle: string,
}> = (targetAchieved: boolean) => ({
  CRITICAL: {
    messageType: 'critical',
    message: "Non sei in linea con l'obiettivo. <strong><u>Scopri perché</u></strong>",
    icon: ICON_ALERT_CIRCLE_OUTLINE,
    modalTitle: `Obiettivo "{METRIC}" ${targetAchieved ? '' : ' ad alto rischio'}`,
  },
  BELOW_EXPECTATIONS: {
    messageType: 'warning',
    message: "Non sei in linea con l'obiettivo. <strong><u>Scopri perché</u></strong>",
    icon: ICON_ALERT_CIRCLE_OUTLINE,
    modalTitle: `Obiettivo "{METRIC}" ${targetAchieved ? '' : ' a rischio'}`,
  },
  NEARLY_ON_TRACK: {
    messageType: 'info',
    message: "Sei quasi in linea con l'obiettivo. <strong><u>Scopri perché</u></strong>",
    icon: ICON_THUMB_UP_OUTLINE,
    modalTitle: `Obiettivo "{METRIC}" ${targetAchieved ? '' : ' quasi in linea'}`,
  },
  ON_TRACK: {
    messageType: 'info',
    message: "Sei in linea con l'obiettivo. <strong><u>Scopri perché</u></strong>",
    icon: ICON_THUMB_UP_OUTLINE,
    modalTitle: `Obiettivo "{METRIC}" ${targetAchieved ? '' : ' in linea'}`,
  },
  ABOVE_EXPECTATIONS: {
    messageType: 'success',
    message: "Sei in linea con l'obiettivo. <strong><u>Scopri perché</u></strong>",
    icon: ICON_THUMB_UP_OUTLINE,
    modalTitle: 'Obiettivo "{METRIC}" sopra le aspettative',
  },
});

export const configByMetric: Record<GoalMetric, {
  titleMarkdown: string,
  chartCaption: string,
  helperContent: string,
  translation: string,
}> = {
  rumors: {
    translation: 'Notizie',
    titleMarkdown: 'Hai inserito **{PERFORMANCE} notizie** su {GOAL} previste',
    chartCaption: 'Notizie annuali',
    helperContent: 'Il numero di notizie settimanali è calcolato sulla base di un CR1 medio (appuntamenti/notizie) del 25%.',
  },
  assignments: {
    translation: 'Mandati',
    titleMarkdown: 'Hai acquisito **{PERFORMANCE} mandati** su {GOAL} previsti',
    chartCaption: 'Mandati annuali',
    helperContent: 'Il numero di mandati mensili è calcolato sulla base di un CR3 medio (vendite/mandati) del 35%.',
  },
  prospects: {
    translation: 'Valutazioni',
    titleMarkdown: 'Hai effettuato **{PERFORMANCE} valutazioni** su {GOAL} previste',
    chartCaption: 'Valut. annuali',
    helperContent: 'Il numero di valutazioni settimanali è calcolato sulla base di un CR2 medio (mandati/valutazioni) del 25%.',
  },
  sales: {
    translation: 'Vendite',
    titleMarkdown: 'Hai concluso **{PERFORMANCE} vendite** su {GOAL} previste',
    chartCaption: 'Vendite annuali',
    helperContent: 'Il numero di vendite è calcolato sulla base di un 50% di vendite derivanti da notizie e 50% derivanti da lead Dove e una commissione media di {AVG_COMMISSIONS}.',
  },
};
